import {connect} from 'react-redux';
import {reportUser} from 'shared/actions/connections';
import ReportUserModal from '../components';

const mapDispatchToProps = (dispatch) => ({
  reportUser: (identifier, message) => dispatch(reportUser({identifier, message})),
});

export default connect(null, mapDispatchToProps)(ReportUserModal);
